import React, { useEffect } from "react";

import { Button } from "react-bootstrap";

import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "src/routes";

import MoreInfoACBannerImg from "@assets/Images/MoreInfoACBannerImg.jpg";
import MoreInfoACBannerMobileImg from "@assets/Images/MoreInfoACBannerMobileImg.jpg";
import FAQAccordionGroup from "@components/component-library/Atoms/FAQAccordionGroup/FAQAccordionGroup";
import BannerThreeToEightCols from "@components/component-library/Molecules/BannerThreeToEightCols/BannerThreeToEightCols";
import PublicPagesWrapper from "@components/component-library/Wrappers/PublicPagesWrapper";
import { useAuthenticationContext } from "@context/authentication";
import { FAQs } from "@util/FAQs";

import styles from "./MoreInfo.module.scss";

const AC = () => {
  const { auth } = useAuthenticationContext();
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <PublicPagesWrapper className={styles["main-wrapper"]}>
        <div className={styles["card-image"]}>
          <div className={styles["image-container"]}>
            <img
              src={MoreInfoACBannerImg}
              alt="Banner image"
              className={classNames(styles["banner-image"], "d-none d-md-block")}
              height="560px"
            />
            <img
              src={MoreInfoACBannerMobileImg}
              alt="Banner image"
              className={classNames(styles["banner-image"], "d-md-none")}
            />
            <div className={styles["image-text"]}>
              <h1 className="d-none d-md-block mb-4">Art centre</h1>
              <h2 aria-level={1} className="d-md-none mb-4">
                Art centre
              </h2>
              <Button
                role="link"
                onClick={() => {
                  navigate(auth?.signInDetails?.loginId ? ROUTES.Dashboard.path : ROUTES.ExternalRegister.path);
                }}
                variant="secondary"
                className={styles["action-button"]}
                size="lg"
              >
                {auth?.signInDetails?.loginId ? "Dashboard" : "Register now"}
              </Button>
            </div>
          </div>
          <caption className="align-self-end text-end monoGrey1 b5 medium py-0">image credit: Felix Cesare</caption>
        </div>
        <div className="h3 mb-0">
          There are different implications for art centres that buy and resell artworks than for art centres who operate
          as an agent for their artists.
        </div>
        <div className="py-5">
          <BannerThreeToEightCols
            heading="The role of art centres"
            content={
              <div className="h3 mb-0">
                <p>
                  <ul>
                    <li className="mb-2">report all resales of $1,000 or more to us</li>
                    <li className="mb-2">
                      pay a 5% royalty if you bought the artwork after 9 June 2010, and you resell it for $1,000 or
                      more.
                    </li>
                  </ul>
                </p>
              </div>
            }
          />
        </div>
        <p className="h3 mb-0">
          If your art centre sells artworks as an agent for your artists, you do not have to report the sales to us.
          However, we encourage you to do so, as this information can help us to work out whether a later sale of an
          artwork is eligible for a royalty. You can simply report the first sale of an artwork online as a ‘primary
          sale’. There will be no royalty payable on the first sale of an artwork.
        </p>
        <p className="h3 mb-0">For more information, refer to FAQs below.</p>
        <p className="h3 mb-0">To report resales to Copyright Agency, you need to register.</p>
        <div>
          <Button
            role="link"
            onClick={() => {
              navigate(auth?.signInDetails?.loginId ? ROUTES.Dashboard.path : ROUTES.ExternalRegister.path);
            }}
            variant="primary"
            size="lg"
          >
            {auth?.signInDetails?.loginId ? "Dashboard" : "Register now"}
          </Button>
        </div>
        <div className={styles["faq-wrapper"]}>
          <BannerThreeToEightCols heading="FAQs" content={<FAQAccordionGroup qnas={FAQs.artCenter} />} />
        </div>
      </PublicPagesWrapper>
    </div>
  );
};

export default AC;
